export default {
  title: 'Instellingen',
  fields: {
    discount_type: {
      label: 'Kortingstype',
    },
  },
  buttons: {
    save: 'Opslaan',
    cancel: 'Annuleren',
  },
  toasts: {
    update_successful: 'Bijgewerkt',
    updated_failed: 'Bijwerken mislukt',
  },
};
